import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'
import DatosJerarquicos from '../../../components/tables/DatosJerarquicos'

const FormasPago = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos
    const [idFormaPago, setIdFormaPago] = useState("")
    const [idFormaPagoDetalle, setIdFormaPagoDetalle] = useState("")
    const [formasPago, setFormasPago] = useState("")
    const [formaPago, setFormaPago] = useState("")
    const [cuota, setCuota] = useState("")
    const [porcentaje, setPorcentaje] = useState("")
    const [porcentajes, setPorcentajes] = useState({})
    const [cuotas, setCuotas] = useState("")
    // modales
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEditarFormaPago, setMostrarModalEditarFormaPago] = useState(false)
    const [mostrarModalConfirmacion, setMostrarModalConfirmacion] = useState(false)
    // notificaiones y carga
    const [error, setError] = useState("")
    const [cargando, setCargando] = useState(true)
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)

    // Obtener datos iniciales de la API al montar el componente
    useEffect(() => { obtenerFormasPago() }, [])

    // Función para obtener las formas de pago desde la API
    const obtenerFormasPago = async () => {
        const respuesta = await consumirApi('GET', `maestros/forma-pago-detalle/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Registrar una nueva forma de pago con cuotas
    const registrarFormasPago = async (e) => {
        e.preventDefault()
        // Validar porcentajes antes de continuar
        if (!validarPorcentajes()) return
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/forma-pago`, formData)
        if (respuesta.success) {
            const idFormaPago = respuesta.data.id
            // Registrar cuotas asociadas a la forma de pago
            const cuotasData = [];
            for (let i = 0; i < cuotas; i++) {
                const cuota = parseInt(formData.get(`cuota_${i + 1}`))
                const porcentaje = parseInt(formData.get(`porcentaje_cuota_${i + 1}`))
                if (cuota && porcentaje) {
                    cuotasData.push({ forma_pago_id: idFormaPago, numero_cuota: cuota, porcentaje })
                }
            }

            for (let cuotaData of cuotasData) {
                const respuestaCuotas = await consumirApi('POST', `maestros/forma-pago-detalle`, cuotaData)
                if (!respuestaCuotas.success) {
                    setError('Error al registrar las cuotas')
                    return
                }
            }
            setNotificacion({ estado: true, tipo: "exito", mensaje: "Forma de pago y cuotas registradas correctamente" })
            limpiarCampos()
            obtenerFormasPago()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Abrir modal para editar una cuota
    const abrirModalEditarFormaPago = (data) => {
        setIdFormaPago(data.id)
        setFormaPago(data.descripcion)
        setMostrarModalEditarFormaPago(true)
    }

    // Enviar los cambios de una cuota editada
    const enviarEdicionFormaPago = async (e) => {
        e.preventDefault()
        const data = { forma_pago: formaPago, }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/forma-pago/${idFormaPago}`, data)

        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Forma de pago actualizada correctamente" })
            limpiarCampos()
            obtenerFormasPago()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar el cambio en los porcentajes de las cuotas
    const manejarCambioPorcentaje = (e) => {
        const { name, value } = e
        setPorcentajes((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    // Abrir modal para editar una cuota
    const abrirModalEditar = (data) => {
        setIdFormaPagoDetalle(data.id)
        setCuota(data.nombre)
        setPorcentaje(data.detalle)
        setMostrarModalEditar(true)
    }

    // Validar que los porcentajes ingresados sean correctos
    const validarPorcentajes = () => {
        const porcentajesValidos = Object.values(porcentajes).every((porcentaje) => porcentaje !== '' && parseFloat(porcentaje) > 0)
        const total = Object.values(porcentajes).reduce((acc, porcentaje) => acc + parseFloat(porcentaje) || 0, 0)
        const sonValidos = porcentajesValidos && total === 100
        if (!sonValidos) {
            setError("Los porcentajes deben ser mayores a 0, estar completos y sumar exactamente 100.")
        }
        return sonValidos
    }

    // Enviar los cambios de una cuota editada
    const enviarEdicionFormaPagoDetalle = async (e) => {
        e.preventDefault()
        const data = { porcentaje }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/forma-pago-detalle/${idFormaPagoDetalle}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Cuota actualizada correctamente" })
            limpiarCampos()
            obtenerFormasPago()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Abrir modal de confirmación para eliminar una forma de pago
    const abrirModalEliminar = (id) => {
        setIdFormaPago(id)
        setMostrarModalConfirmacion(true)
    }

    // Eliminar una forma de pago
    const eliminarFormaDePago = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/forma-pago/${idFormaPago}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Forma de pago eliminada correctamente" })
            setMostrarModalConfirmacion(false)
            obtenerFormasPago()
        } else {
            setError(respuesta.error)
        }
    }

    // Limpiar campos del formulario y estados relacionados
    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalConfirmacion(false)
        setMostrarModalEditar(false)
        setMostrarModalEditarFormaPago(false)
        setError('')
        setFormasPago('')
        setFormaPago('')
        setCuotas('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron formas de pago</div>
                ) : (
                    <div className="max-h-content overflow-y-auto">
                        <DatosJerarquicos
                            data={datos}
                            eliminar={abrirModalEliminar}
                            eliminarDetalle={() => { }}
                            editar={abrirModalEditar}
                            editarPadre={abrirModalEditarFormaPago}
                            registrar={() => { }}
                            campoTitulo="forma_pago"
                            campoDetalles="forma_pago_detalle"
                            campoNombre="numero_cuota"
                            campoDetalle="porcentaje"
                            nombreTitulo='Cuota'
                            nombreDetalle='Porcentaje %'
                        />
                    </div>
                )
            )}

            {/* Modal Registrar nuevo Formas de pago*/}
            <Modal isOpen={mostrarModal} title="Registrar nueva Forma de pago" onClose={limpiarCampos} >
                <Form onSubmit={registrarFormasPago} isSubmitting={isSubmitting}>
                    <Input name="forma_pago" value={formasPago} label="Forma de pago" onChange={setFormasPago} />
                    <Input name="cuotas" value={cuotas} label="Numero de cuotas" onChange={setCuotas} type="number" />
                    {
                        cuotas && (
                            <>
                                {[...Array(Math.min(parseInt(cuotas), 4))].map((_, index) => (
                                    <div key={index} className='flex gap-3'>
                                        {/* Cuota */}
                                        <div className="flex flex-col w-full md:w-1/2">
                                            <label>Cuota {index + 1}</label>
                                            <input
                                                id={`cuota_${index + 1}`}
                                                name={`cuota_${index + 1}`}
                                                value={index + 1} // O el valor que desees aquí
                                                className="border p-1 w-full border-blue-300"
                                                readOnly
                                            />
                                        </div>

                                        {/* Porcentaje */}
                                        <div className="flex flex-col w-full md:w-1/2 mb-2">
                                            <label>Porcentaje cuota {index + 1}</label>
                                            <input
                                                id={`porcentaje_cuota_${index + 1}`}
                                                name={`porcentaje_cuota_${index + 1}`}
                                                type="number"
                                                value={porcentajes[`porcentaje_cuota_${index + 1}`] || ''}
                                                onChange={(e) => manejarCambioPorcentaje({ name: e.target.name, value: e.target.value })}
                                                className="border p-1 w-full border-blue-300"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </>
                        )
                    }
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modales para editar forma de pago */}
            <Modal isOpen={mostrarModalEditarFormaPago} title="Actualizar forma de pago" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionFormaPago} isSubmitting={isSubmitting} >
                    <Input name="forma_pago" value={formaPago} label="Forma de pago" onChange={setFormaPago} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal para editar un detalle de forma de pago*/}
            <Modal isOpen={mostrarModalEditar} title={`Editar cuota ${cuota}`} onClose={limpiarCampos}>
                <Form onSubmit={enviarEdicionFormaPagoDetalle} type="update" isSubmitting={isSubmitting} >
                    <Input name="porcentaje" value={porcentaje} type="number" label="Porcentaje" onChange={setPorcentaje} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar una forma de pago */}
            <ModalConfirmacion
                isOpen={mostrarModalConfirmacion}
                onClose={limpiarCampos}
                onConfirm={eliminarFormaDePago}
                mensaje="¿Estás seguro de que deseas eliminar esta forma de pago, ten en cuenta que se eliminara todas sus cuotas asociadas?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default FormasPago
